<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-10">
        <div class="text-center mb-4">
          <h2>Utah Preference Points</h2>
          <p class="text-muted">Manage your hunting preference points</p>
        </div>
        
        <!-- DrawPointsTable with upgrade invitation -->
        <DrawPointsTable :data="[]" @row-click="handleRowClick" />
        
        <!-- Back to Home button -->
        <div class="text-center mt-4">
          <button class="btn btn-outline-secondary" @click="$emit('show-home')">
            <i class="mdi mdi-arrow-left me-2"></i>
            No thanks, go to Draw Odds
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrawPointsTable from './DrawPointsTable.vue';

export default {
  name: 'DrawPointsUpgradeView',
  components: {
    DrawPointsTable,
  },
  methods: {
    handleRowClick(item) {
      // Since this is for non-premium users with empty data, 
      // this won't be called, but we include it for consistency
      console.log('Row clicked:', item);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 1000px;
}
</style>
